import {Component, OnDestroy, OnInit} from '@angular/core';
import {TaskOptionsService} from '../../../../services/task-options.service';
import {AlertService} from '../../../../services/notify/alert.service';
import {Subscription} from 'rxjs';
import {PropertiesService} from '../../../../services/api/properties-service.service';
import {ValuePropertyModel} from '../../../../models/property.model';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-task-properties',
    templateUrl: './task-properties.component.html',
    styleUrls: ['./task-properties.component.scss']
})
export class TaskPropertiesComponent implements OnInit, OnDestroy {

    subs: Subscription;

    keys: [
        'property_file',
        'property_member',
        'property_text',
        'property_boolean',
        'property_catalog'
    ] = [
        'property_file',
        'property_member',
        'property_text',
        'property_boolean',
        'property_catalog'
    ];

    boardProperties: ValuePropertyModel[];

    constructor(
        public taskOptionsService: TaskOptionsService,
        public alert: AlertService,
        private propertiesService: PropertiesService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        if (this.taskOptionsService.selectedBoard) {
            this.afterRefreshProperties();
        }

        this.subs = this.taskOptionsService.emitChangeBoard.subscribe(() => {
            this.afterRefreshProperties();
        });
    }

    ngOnDestroy(): void {
        this.subs.unsubscribe();
    }

    afterRefreshProperties(): void {
        this.getBoardProperties();
    }

    getBoardProperties(): void {
        this.boardProperties = this.taskOptionsService.selectedBoard.custom_properties;
    }

    saveProp(newProperties: ValuePropertyModel[]): void {
        this.boardProperties = newProperties;
        this.editProperties();
    }

    editProperties(): void {
        const saveData = [];
        this.boardProperties.map(prop => {
            const elem = {
                property_default_view: prop.default_view,
                property_id: prop.property.id,
            };
            saveData.push(elem);
        });

        this.propertiesService.addOrDeletePropertyInBoard(this.taskOptionsService.selectedBoard.alias, saveData).subscribe({
            next: () => {
                this.alert.setAlert(this.translate.instant('ALERTS.SUCCESS'), 'green');
            }, error: err => {
                this.alert.setAlert(err.message, 'blue');
            }
        });
    }
}
